import React, { Component } from "react";
import axios from "axios";
import { apiUrl } from "../../config/config";
import classnames from "classnames";
import $ from "jquery";
import socketIOClient from "socket.io-client";
import { MDBDataTable } from "mdbreact";
import ProgressBtn from "../../components/common/ProgressButton";
import TopNav from "../../components/common/TopNav";
import SideBar from "../../components/common/SideBar";
import AddModalComplete from "../verifier/AddModalComplete";
import "react-dropdown/style.css";
import { Toaster, toast } from "react-hot-toast";
import "./labledpatints.css";
import Datetime from "react-datetime";
import "react-datetime/css/react-datetime.css";

import Select from "react-select";
// eslint-disable-next-line import/no-webpack-loader-syntax
import Worker from "worker-loader!./worker.js";
import { ar } from "date-fns/locale";

// Live progress socket disabled — re-enable once the backend at
// https://web.mybiocalculus.com:5000 has CORS configured for cross-origin
// credentialed requests. ProgressButton handles socket === null gracefully.
// const socket = socketIOClient("https://web.mybiocalculus.com:5000");
const socket = null;

const customStyles = {
  root: {
    display: "flex",
    alignItems: "center",
  },
  wrapper: {
    margin: "10px",
    position: "relative",
  },
  linearProgress: {
    position: "absolute",
    top: 0,
    width: "100%",
    height: "100%",
    opacity: 0.4,
    borderRadius: 4,
  },
};
class LabledPatients extends Component {
  constructor() {
    super();
        const menus = [
          { title: "Verifier Home", url: "/verifier-home" },
          { title: "Patient list", url: "/patient-list" },
          { title: "Labled Patients", url: "/labled-patients" },
          { title: "Verified", url: "/verification-completed" },
    
        ];
        if (localStorage.getItem("verifiertype") === "8") {
          menus.splice(2, 0, { title: "Patient-hold", url: "/patient-hold" });
        }
     if (localStorage.getItem("AdminUser") === "8") {
       menus.splice(3, 0, { title: "Device Deatils", url: "/device-details" });
       menus.splice(4, 0, { title: "Battery Issue", url: "/battery-issue" });
     }
    
        if (localStorage.getItem("verifiertype") === "8") {
          menus.splice(4, 0, { title: "Support Home", url: "/support-home" });
        }
        if (localStorage.getItem("verifiertype") === "8") {
          menus.splice(5, 0, { title: "QC Home", url: "/qc_home" });
        }
        if (localStorage.getItem("verifiertype") === "8") {
          menus.splice(6, 0, { title: "Support Web", url: "/support-homeweb" });
        }
        if (localStorage.getItem("AdminUser") === "8") {
          menus.splice(6, 0, { title: "Report Shared", url: "/report-shared" });
        }
        if (localStorage.getItem("AdminUser") === "8") {
          menus.splice(6, 0, {
            title: "Supported Person",
            url: "/supported-persons",
          });
         
          }
           if (localStorage.getItem("AdminUser") === "8") {
            menus.splice(6, 0, {
              title: "Reset Password",
              url: "/ResetPassword",
            });
        }
    this.state = {
      menus,
      isModalCompleteOpen: false,
      profileLink: "verifier-profile",
      patients: [],
      nor_minhr: "",
      nor_maxhr: "",
      qtcformula: "",
      qtcvalue_min: "",
      qtcvaluemax: "",
      qrswidth_min: "",
      qrswidth_max: "",
      qrsamp_min: "",
      qrsamp_max: "",
      stelevation: "",
      pwidth_min: "",
      pwidth_max: "",
      pamp_min: "",
      pamp_max: "",
      stdepression: "",
      twidth_min: "",
      twidth_max: "",
      tamp_min: "",
      tamp_max: "",
      printerval_min: "",
      printerval_max: "",
      tachyhr_lower: "",
      tachyhr_upper: "",
      bradyhr_lower: "",
      bradyhr_upper: "",
      pauselength: "",
      graph_gen: "",
      errors: {},
      userid: "",
      duration: "",
      smoking: "",
      diabetes: "",
      height: "",
      weight: "",
      hospital: "",
      phone: "",
      patient_name: "",
      email_id: "",
      dob: "",
      af: "",
      hyper_tension: "",
      hyper_lipidemia: "",
      indication: "",
      thyroid_function: "",
      cardiac_surgery: "",
      doctors: [],
      verifiers: [],
      selectedVerifierIds: [],
      selectedVerifiers: [],
      doctor_id: "",
      doctor_name: "Choose",
      selectedDoctor: null,
      data: {},
      prog_data: 0,
      loading: false,
      // socketNew: socket,
      patientDetails: null,
      ipop: "",
      priority: "",
      reportstatus: "",
      percentageVerified: "",
      verifiertype: "",
      comments: "",
      newComment: "",
      customermailid: "",
      mailuserid: "",
      device_id: "",
      patientName: "",
      mailsubject: "",
      whatsappNumber: "",
      arrythymia: "",
      whatsappUserid: "",
      columns: [],
      rows: [],
      searchQuery: "",
      currentPage: 1,
      rowsPerPage: 50,
      pacemaker: false,
      issueReport: "",
      reportPhone: "",
      selectedType: "customer", // Add this line to set the default value
      patientmailid: "",
      patientmailsubject: "",
      patientwhatsappNumber: "",
      patientwhatsappMessage: "",
      setCompletionDate: this.getCurrentDateTime(),
      isConfirmationModalOpen: "",
      selecetdConfirmation: "",
      selectedPatientId: null,
      selectedLabels: [],
      selectedPeriod: "daily", // Add this line to set the default value
    };
    this.selectItem = this.selectItem.bind(this);
    this.getInfo = this.getInfo.bind(this);
    this.sentMailReport = this.sentMailReport.bind(this);
    this.sentWhatsappReport = this.sentWhatsappReport.bind(this);
    this.preventDefault = this.preventDefault.bind(this);
    this.filterRows = this.filterRows.bind(this);
    this.handleRowClick = this.handleRowClick.bind(this);
    this.handleConfirmationClick = this.handleConfirmationClick.bind(this);
    this.handleConfirmationChange = this.handleConfirmationChange.bind(this);
    this.handleConfirmationSubmit = this.handleConfirmationSubmit.bind(this);
    this.handleConfirmationCancel = this.handleConfirmationCancel.bind(this);
  }

  componentDidMount() {
    if (
      (localStorage.getItem("verifiertype") !== "8") &
      (localStorage.getItem("verifiertype") !== "2")
    ) {
      this.props.history.push("/error");
    } else {
      this.fetchData();
    }
  }
  getCurrentDateTime = () => {
    const now = new Date();
    now.setMinutes(now.getMinutes() + 330); // Adjust UTC time by +5:30 (330 minutes)
    return now.toISOString().slice(0, 16); // Convert to "YYYY-MM-DDTHH:MM"
  };
  fetchData = (e) => {
    const verifiertype = localStorage.getItem("verifiertype");
    // console.log('verifierid:',verifiertype)
    this.setState({ verifiertype: verifiertype });
    const worker = new Worker();

    function capitalizeFirstLetter(string) {
      return string.charAt(0).toUpperCase() + string.slice(1);
    }
    var newstat = this;
    /*socket.on('connect', function(){console.log('connected')});
    socket.on('connect_error', function(err){console.log(err)});
    socket.on('data', function(data){


      newstat.setState({"loading":true});
      
      console.log(newstat.state.loading)
    });
    socket.on('disconnect', function(){console.log('disconnected')});*/
    //   axios
    //        .get(apiUrl+'api/users/alldoctors')
    //        .then(res => {
    //          this.setState({ ['doctors']: res.data })
    //        })
    //        .catch(err => {
    //          this.setState({ ['doctors']: [] })
    //        });

    worker.postMessage({
      name: "alldoctors",
      url: apiUrl + "api/users/alldoctors",
    });
    worker.onmessage = function (event) {};
    worker.addEventListener("message", function (event) {
      newstat.setState({ ["doctors"]: event.data });
      //console.log(newstat.state.doctors);
    });
    axios
      .get(apiUrl + "api/users/getVerifierPatientsLabel")
      .then((res) => {
        const sortedData = res.data.sort((a, b) => {
          const reportOrder = { 0: 5, 2: 4, 4: 3, 5: 2 }; // Order for report_status
          const aReportStatus = reportOrder[a.report_status] || 5;
          const bReportStatus = reportOrder[b.report_status] || 5;

          if (aReportStatus !== bReportStatus) {
            return aReportStatus - bReportStatus;
          }

          // Then, sort by backup_status (1 should come last)
          const aBackupStatus = a.backup_status === 1 ? 2 : 1;
          const bBackupStatus = b.backup_status === 1 ? 2 : 1;

          if (aBackupStatus !== bBackupStatus) {
            return aBackupStatus - bBackupStatus;
          }
        });

        // Set the sorted patients data in state
        this.setState({
          patients: sortedData,
        });
        // console.log('whatsapp sent time', this.state.patients.whatsappsenttime);

        // Loop through object keys if it's not an array
        if (
          typeof this.state.patients === "object" &&
          this.state.patients !== null
        ) {
          Object.keys(this.state.patients).forEach((key) => {
            // console.log(
            //   "whatsapp sent time",
            //   this.state.patients[key].whatsappsenttime
            // );
            // console.log("mail sent time", this.state.patients[key].mailsentime);
          });
        }

        const data = {
          columns: [
            {
              label: "SL NO",
              field: "slno",
              sort: "asc",
              width: 5,
            },
            {
              label: "PATIENT ID",
              field: "patientId",
              sort: "asc",
              width: 70,
            },
            {
              label: "ADDED DATE",
              field: "added_date",
              sort: "asc",
              width: 70,
            },
            {
              label: "NAME",
              field: "name",
              sort: "asc",
              width: 130,
            },

            {
              label: "Action",
              field: "action",
              sort: "disabled",
              width: 160,
            },
            // {
            //   label: "Lables Marked",
            //   field: "report",
            //   sort: "disabled",
            //   width: 150,
            // },
            {
              label: "Labels Marked",
              field: "report",
              sort: "disabled",
              width: 150,
            },
          ],
          rows: [],
        };

        var onClick = this.selectItem.bind(this);
        var getInfo = this.getInfo.bind(this);

        var preventDefault = this.preventDefault.bind(this);
        var createdData = "";
        const options = [
          "RPeaks",
          "Classic",
          "Classical",
          "Classic Negative",
          "AI",
          "AIcodes",
        ];
        const defaultOption = options[0];
        sortedData.map(function (patient, i) {
          const Priority =
            (patient.deviceInfo && patient.deviceInfo.Priority) || 4; // Set Priority value

          // Variable to store the final time value
          let finalTime;

          // Ensure the date fields are not undefined or null before splitting
          if (patient.ConfirmupdatedDate) {
            // Split the 'ConfirmupdatedDate' by 'T' to get the date and time parts
            let confirmButtonTime = patient.ConfirmupdatedDate.split("T");

            // Get the date part before 'T'
            let confirmDate = confirmButtonTime[0]; // '2024-11-29'

            // Get the time part after 'T'
            let confirmTime = confirmButtonTime[1]
              ? confirmButtonTime[1].split("Z")[0] // Remove 'Z' if it exists
              : ""; // If no time part, default to an empty string

            // Handle removing milliseconds (if any) from confirmTime
            if (confirmTime) {
              let time = confirmTime.split(".")[0]; // Get time without milliseconds
              const confirmbtnTime = confirmDate + " " + time; // Add a space between date and time
              // console.log("Confirm button time:", confirmbtnTime);

              // Assign confirmbtnTime to finalTime if available
              finalTime = confirmbtnTime;
            } else {
              // console.log("Confirm Time is empty or invalid");
            }
          } else {
            // console.log("ConfirmupdatedDate is undefined or null");
          }

          // Check and split the 'updatedDate' if it's available
          if (patient.updatedDate) {
            // Split the 'updatedDate' by space to separate date and time
            let updatedDateTime = patient.updatedDate.split(" ");

            // Get the date part before the space
            let updatedDate = updatedDateTime[0]; // '2024-11-29'

            // Get the time part after the space
            let updatedTime = updatedDateTime[1]; // '10:28:34'

            // console.log("Updated Date:", updatedDate, updatedTime);

            // Combine updatedDate and updatedTime with a space between them
            const uploadedTime = updatedDate + " " + updatedTime;

            // Assign uploadedTime to finalTime if confirmbtnTime was not set
            if (!finalTime) {
              finalTime = uploadedTime;
            }
          } else {
            // console.log("UpdatedDate is undefined or null");
          }

          // Log the final time
          // console.log("Final Time:", finalTime);

          // Get the current time
          const now = new Date();

          // Convert finalTime to Date object
          const finalDate = new Date(finalTime);

          // Calculate the time difference in milliseconds
          const timeDifference = now - finalDate; // in milliseconds

          // Convert time difference to hours
          const hoursDifference = timeDifference / (1000 * 60 * 60); // milliseconds to hours

          // Set the time limit based on priority
          let timeLimit;
          switch (Priority) {
            case 1:
              timeLimit = 1; // 1 hours
              break;
            case 2:
              timeLimit = 2; // 3 hours
              break;
            case 3:
              timeLimit = 3;
            case 4:
              timeLimit = 4; // 4 hours
              break;
            case 5:
              timeLimit = 5; // 8 hours
              break;
            default:
              timeLimit = 4; // 10 hours (for priority 5, as an example)
          }

          // Calculate the percentage of time used

          let exp_device =
            patient.exp_device_use_days === 24
              ? 1
              : patient.exp_device_use_days === 48
              ? 2
              : patient.exp_device_use_days === 72
              ? 3
              : patient.exp_device_use_days;

          let timePercentage =
            // (hoursDifference / (timeLimit * exp_device)) * 100;
            (hoursDifference / (timeLimit * exp_device)) * 100; // Calculate the percentage of time used
          // *
          // patient.exp_device_use_days
          if (timePercentage > 100) {
            timePercentage = 100; // Limit to 100% if the time exceeds the limit
          }
          // Calculate the completion rate (percentage per hour)
          // Calculate the completion rate (percentage per hour)
          const completionRate = timePercentage / hoursDifference; // percentage per hour

          // Predict the total time to complete 100% (in hours)
          const totalCompletionTime = 100 / completionRate; // in hours

          // Calculate the remaining time to complete (in hours)
          const remainingTimeInHours = totalCompletionTime - hoursDifference;

          // Convert the remaining time to minutes
          const remainingTimeInMinutes = remainingTimeInHours * 60;

          // Convert minutes into hours and minutes
          const hours = Math.floor(remainingTimeInMinutes / 60); // Extract whole hours
          const minutes = Math.round(remainingTimeInMinutes % 60); // Get the remaining minutes

          // Log the predicted remaining time
          // console.log(
          //   `Predicted Remaining Time: ${hours} hours and ${minutes} minutes`
          // );

          // console.log("name", patient.name);
          // console.log("percetage", timePercentage);
          // console.log("timediff", timeDifference);
          // console.log("time limit", timeLimit);

          // Log the result
          // console.log(`Time used: ${hoursDifference.toFixed(2)} hours`);
          // console.log(`Time limit for Priority ${Priority}: ${timeLimit} hours`);
          // console.log(`Percentage of time used: ${timePercentage.toFixed(2)}%`);
          const percentage = timePercentage.toFixed(2);
          // console.log(patient);
          var url = " ";
          if (patient.LastDatasetId != undefined) {
            if (
              patient.backup_status == 0 ||
              patient.backup_status == undefined
            ) {
              url =
                "/verifier-unanalysed/" +
                patient._id +
                "/" +
                patient.LastDatasetId;
            } else {
              url = " ";
            }
          }

          var anl_btn_txt = "teststart";
          var anl_btn_class = "btn-danger";
          var gen_btn_txt = "Not Generated";
          var gen_btn_class = "btn-danger";
          var report_link = "#";
          var report_link_target = "";
          var report_status = patient.report_status;
          window.backup_status = patient.backup_status;
          if (patient.report_status == 1) {
            anl_btn_txt = "Analyzing...";
            anl_btn_class = "btn-success";
          }
          if (patient.report_status >= 2) {
            if (
              patient.backup_status == 0 ||
              patient.backup_status == undefined
            ) {
              url =
                "/addlabel-chart/" + patient._id + "/" + patient.LastDatasetId;
              // console.log('percentage!!!!!!!!!!!!!!!!!', patient)
            } else {
              url = " ";
            }
            anl_btn_txt = "test";
            anl_btn_class = "btn-success";
          }
          if (patient.report_status >= 4) {
            gen_btn_txt = "In Preparation";
            gen_btn_class = "btn-yellow";
          }
          if (patient.report_status >= 5) {
            gen_btn_txt = "View Report";
            gen_btn_class = "btn-success";
            report_link_target = "_blank";
          }

          if (
            patient.backup_status == 0 ||
            patient.backup_status == undefined
          ) {
            anl_btn_txt = "TEST3";
          } else if (patient.backup_status == 1) {
            anl_btn_txt = "Retrieve";
          } else if (patient.backup_status == 2) {
            anl_btn_txt = "Retrieving";
          }
          createdData = patient.created_at.split("T");
          // console.log('patient!!!!!!!!!!!!!!!!!!!!!!!!!!!!!',patient)
          const formattedDate = new Date(
            patient.ConfirmupdatedDate || patient.updatedDate
          ).toLocaleString("en-US", {
            month: "2-digit",
            day: "2-digit",
            year: "numeric",
            hour: "2-digit",
            minute: "2-digit",
            hour12: true,
          });

          data.rows.push({
            slno: i + 1,
            patientId: patient.device_id,
            added_date: createdData[0],

            name: capitalizeFirstLetter(patient.name),
            action: (
              <React.Fragment>
                <div style={{ display: "flex", gap: "8px", justifyContent: "center", alignItems: "center" }}>
                  {this.state.verifiertype === "8" && (
                    <button
                      type="button"
                      id={patient._id}
                      onClick={getInfo}
                      data-toggle="modal"
                      data-target="#editInfoModal"
                      title="Edit"
                      style={{
                        background: "#1a5a62",
                        border: "1px solid #2eaabb",
                        borderRadius: "7px",
                        width: "34px",
                        height: "34px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        cursor: "pointer",
                        padding: 0,
                      }}
                    >
                      <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="#2eaabb" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
                        <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"/>
                        <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"/>
                      </svg>
                    </button>
                  )}
                  <button
                    type="button"
                    id={patient._id}
                    onClick={getInfo}
                    data-toggle="modal"
                    data-target="#commentinfomodal"
                    title="Comments"
                    style={{
                      background: "#1a4a2e",
                      border: "1px solid #2eaa6a",
                      borderRadius: "7px",
                      width: "34px",
                      height: "34px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      cursor: "pointer",
                      padding: 0,
                    }}
                  >
                    <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="#2eaa6a" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
                      <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/>
                    </svg>
                  </button>
                </div>
              </React.Fragment>
            ),

            report: (
              <React.Fragment>
                <input type="hidden" className="patientLink" value={url} />
                {patient.MarkedLabel && patient.MarkedLabel.length > 0 ? (
                  <div
                    style={{ display: "flex", flexWrap: "wrap", gap: "1px" }}
                  >
                    {patient.MarkedLabel.map((label, index) => {
                      // Define colors for each label
                      const labelColors = {
                        ST: "#00FFFF",
                        VT: "#A64D79",
                        NSR: "#3D761D",
                        AF: "#9900FF",
                        PVC: "#FF00FF",
                        PAC: "#0000FF",
                        SB: "#FF9900",
                        SP: "#FF0000",
                        "3AVB": "#bfbebb",
                        CHB: "#7f6000",
                        "2AVB": "#351c75",
                        SVT: "#980000",
                        JB: "#46bdc6",
                        UN: "#FFD966",
                        PACED: "#FF0000",
                      };

                      // Get the color for the current label, default to gray if not defined
                      const backgroundColor = labelColors[label] || "gray";

                      return (
                        <div
                          key={index}
                          onClick={async () => {
                            console.log("Label clicked:", label);
                            console.log("Patient ID:", patient._id);
                            const getlabeledPatients = await axios.get(
                              `${apiUrl}api/common/getLabledBeats?userid=${patient._id}`
                            );
                            console.log(
                              "Labeled Patients:",
                              getlabeledPatients.data
                            );
                            // Display the response data in a popup
                            const responseData = getlabeledPatients.data.data;
                            if (responseData && responseData.length > 0) {
                              const popupContent = [];
                              let startBeat = null;
                              let previousBeat = null;
                              let previousArrhythmia = null;

                              responseData.forEach((item, index) => {
                                if (
                                  previousBeat !== null &&
                                  item.indexcounter === previousBeat + 1 &&
                                  item.arrhythmia === previousArrhythmia
                                ) {
                                  // Continuing sequence with the same arrhythmia
                                  if (startBeat === null) {
                                    startBeat = previousBeat;
                                  }
                                } else {
                                  // Sequence breaks, push the previous sequence
                                  if (startBeat !== null) {
                                    popupContent.push(
                                      `Beat No: ${startBeat} - ${previousBeat}, Arrhythmia: ${previousArrhythmia}, Peak Time: ${
                                        responseData.find(
                                          (beat) =>
                                            beat.indexcounter === startBeat
                                        ).peaktime
                                      }, Database ID: ${
                                        responseData.find(
                                          (beat) =>
                                            beat.indexcounter === startBeat
                                        ).databaseid
                                      }`
                                    );
                                    startBeat = null;
                                  }

                                  let arrythymia = item.arrhythmia;
                                  if (item.arrhythmia === "Prolonged QT") {
                                    arrythymia = "JB";
                                  }
                                  if (item.arrhythmia === "P Absent") {
                                    arrythymia = "3AVB";
                                  }
                                  if (item.arrhythmia === "Short QT") {
                                    arrythymia = "1AVB";
                                  }
                                  if (item.arrhythmia === "Irregular RR") {
                                    arrythymia = "CHB";
                                  }
                                  if (item.arrhythmia === "Irregular PR") {
                                    arrythymia = "2AVB";
                                  }
                                  if (item.arrhythmia === "Sinus Bradycardia") {
                                    arrythymia = "SB";
                                  }
                                  if (item.arrhythmia === "Sinus Pause") {
                                    arrythymia = "SP";
                                  }
                                  if (item.arrhythmia === "Sinus Tachycardia") {
                                    arrythymia = "ST";
                                  }
                                  if (
                                    item.arrythymia ===
                                    "Ventricular Tachycardia"
                                  ) {
                                    arrythymia = "VT";
                                  }
                                  if (
                                    item.arrhythmia === "Normal Sinus Rythm"
                                  ) {
                                    arrythymia = "NSR";
                                  }

                                  // Push the current beat if it's not part of a sequence
                                  popupContent.push(
                                    `Beat No: ${item.indexcounter}  ||  Arrhythmia: ${arrythymia}  ||  Peak Time: ${item.peaktime}  ||  Database ID: ${item.databaseid}\n`
                                  );
                                }

                                previousBeat = item.indexcounter;
                                previousArrhythmia = item.arrhythmia;
                              });

                              // Handle the last sequence if it exists
                              if (startBeat !== null) {
                                popupContent.push(
                                  `Beat No: ${startBeat} - ${previousBeat}  ||  Arrhythmia: ${previousArrhythmia}  ||  Peak Time: ${
                                    responseData.find(
                                      (beat) => beat.indexcounter === startBeat
                                    ).peaktime
                                  }  ||  Database ID: ${
                                    responseData.find(
                                      (beat) => beat.indexcounter === startBeat
                                    ).databaseid
                                  }`
                                );
                              }

                              const popupContentString =
                                popupContent.join("\n");

                              const modal = document.createElement("div");
                              modal.style.position = "fixed";
                              modal.style.top = "50%";
                              modal.style.left = "50%";
                              modal.style.transform = "translate(-50%, -50%)";
                              modal.style.backgroundColor = "#fff";
                              modal.style.padding = "20px";
                              modal.style.boxShadow =
                                "0 4px 8px rgba(0, 0, 0, 0.2)";
                              modal.style.zIndex = "1000";
                              modal.style.borderRadius = "8px";
                              modal.style.maxWidth = "80%";
                              modal.style.maxHeight = "80%";
                              modal.style.overflowY = "auto";

                              const modalContent =
                                document.createElement("pre");
                              modalContent.style.whiteSpace = "pre-wrap";
                              modalContent.style.wordWrap = "break-word";
                              modalContent.textContent = `Labeled Beats:\n${popupContent}`;
                              modal.appendChild(modalContent);

                              const closeButton =
                                document.createElement("button");
                              closeButton.textContent = "Close";
                              closeButton.style.marginTop = "10px";
                              closeButton.style.padding = "10px 20px";
                              closeButton.style.backgroundColor = "#007bff";
                              closeButton.style.color = "#fff";
                              closeButton.style.border = "none";
                              closeButton.style.borderRadius = "5px";
                              closeButton.style.cursor = "pointer";
                              closeButton.style.float = "right"; // Align the button to the right
                              closeButton.addEventListener("click", () => {
                                // document.body.removeChild(modal);
                                // document.body.removeChild(overlay);
                              });
                              closeButton.textContent = "Close";
                              closeButton.style.marginTop = "10px";
                              closeButton.style.padding = "10px 20px";
                              closeButton.style.backgroundColor = "#007bff";
                              closeButton.style.color = "#fff";
                              closeButton.style.border = "none";
                              closeButton.style.borderRadius = "5px";
                              closeButton.style.cursor = "pointer";
                              closeButton.addEventListener("click", () => {
                                document.body.removeChild(modal);
                                document.body.removeChild(overlay);
                              });

                              modal.appendChild(closeButton);

                              const overlay = document.createElement("div");
                              overlay.style.position = "fixed";
                              overlay.style.top = "0";
                              overlay.style.left = "0";
                              overlay.style.width = "100%";
                              overlay.style.height = "100%";
                              overlay.style.backgroundColor =
                                "rgba(0, 0, 0, 0.5)";
                              overlay.style.zIndex = "999";
                              overlay.addEventListener("click", () => {
                                document.body.removeChild(modal);
                                document.body.removeChild(overlay);
                              });

                              document.body.appendChild(overlay);
                              document.body.appendChild(modal);
                            } else {
                              alert("No labeled beats found.");
                            }
                            // Add your logic here for handling the label click
                            // For example, you can call a function or navigate to another page
                          }}
                          style={{
                            display: "inline-block",
                            padding: "5px 10px",
                            backgroundColor: backgroundColor,
                            color: "#fff",
                            borderRadius: "1px",
                            fontSize: "12px",
                            textAlign: "center",
                            cursor: "pointer",
                          }}
                        >
                          {label}
                        </div>
                      );
                    })}
                  </div>
                ) : (
                  <span>No Labels</span>
                )}
              </React.Fragment>
            ),
          });
        }, this);
        this.setState({ data: data });
        this.setState({ columns: data.columns });
        this.setState({ rows: data.rows });
      })
      .catch((err) => {});

    $(document).ready(function () {
      $("#mbdTable").on("click", "tr td:nth-child(2)", function () {
        var url = $(this).parent().find(".patientLink").val();
        if (url != " ") {
          window.location.href = url;
          // console.log("url");
        }
      });
      $("#mbdTable").on("click", "tr td:nth-child(3)", function () {
        var url = $(this).parent().find(".patientLink").val();
        if (url != " ") {
          window.location.href = url;
          // console.log("url:", url);
        }
      });
      $("#mbdTable").on("click", "tr td:nth-child(4)", function () {
        var url = $(this).parent().find(".patientLink").val();
        if (url != " ") {
          window.location.href = url;
          // console.log("url");
        }
      });
    });
  };
  handleVerifierChange = (selectedOptions) => {
    this.setState({
      selectedVerifiers: selectedOptions || [], // Update selected verifiers or set empty array if none
    });
    // console.log('selected options',selectedOptions)
    // console.log('selected verifier state',this.state.selectedVerifiers,this.state.selectedVerifierIds)
  };
  handleConfirmationClick(patientId, confirmation) {
    console.log(this.state.patients);
    this.setState({
      isConfirmationModalOpen: true,
      selectedPatientId: patientId,
      selectedConfirmation: confirmation,
    });
  }

  handleConfirmationChange(event) {
    this.setState({ selectedConfirmation: event.target.value });
  }

  handleConfirmationSubmit() {
    const { selectedPatientId, selectedConfirmation } = this.state;
    // Handle the submit action, e.g., make an API call to update the confirmation status
    axios
      .post(`${apiUrl}api/patients/updateConfirmation`, {
        userid: selectedPatientId,
        Confirmation: selectedConfirmation,
      })
      .then((response) => {
        console.log("Confirmation updated:", response.data);
        this.setState({ isConfirmationModalOpen: false });

        toast.success(`Confirmation Updated to : ${selectedConfirmation}`);
        this.fetchData(); // Refresh the data after updating confirmation
      })
      .catch((error) => {
        console.error("Error updating confirmation:", error);
      });
  }

  handleConfirmationCancel() {
    this.setState({ isConfirmationModalOpen: false });
    // console.log('cancel')
  }

  submitComment = async (e) => {
    const userid = e.currentTarget.id;
    const newText = (this.state.newComment || "").trim();
    if (!newText) return;
    const verifiername = localStorage.getItem("verifiername") || "Unknown";
    const timestamp = new Date().toLocaleString("en-IN", { day: "2-digit", month: "short", hour: "2-digit", minute: "2-digit", hour12: true });
    const newEntry = `${newText} — ${verifiername} [${timestamp}]`;
    const existing = (this.state.comments || "").trim();
    const comments = existing ? `${existing}\n${newEntry}` : newEntry;
    try {
      await axios.post(`${apiUrl}api/patients/addComment/${userid}`, { comments });
      $(".closePopup").click();
      this.setState({ newComment: "", comments: "" });
      this.fetchData();
    } catch (error) {
      console.error("Error submitting comment:", error);
    }
  };
  sentMailReport = async (e) => {
    const mailid = this.state.customermailid;
    const userid = this.state.mailuserid;

    if (!userid || !mailid) {
      toast.error("Enter Email ID to proceed");
      return;
    }

    var apiUrl = `${apiUrl}api/users/sendmailReport_new_new_Read_Schedule`;

    var requestBody = {
      userid: userid,
      mailid: mailid,
      mailsubject:
        this.state.mailsubject ||
        `${this.state.patientName}: Biocalculus: ${this.state.device_id}`,
      scheduledTime: this.state.setCompletionDate, // Add scheduled time for customer
    };

    await axios.post(`${apiUrl}api/users/updateMailId`, {
      mailid: this.state.customermailid,
      mac_id: this.state.device_mac,
      phone: this.state.whatsappNumber,
      device_id: this.state.device_id,
    });

    fetch(apiUrl, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(requestBody),
    })
      .then((response) =>
        response.json().then((data) => {
          if (!response.ok)
            throw new Error(data.message || "Failed to send email.");
          return data;
        })
      )
      .then((data) => {
        toast.success(data.message);
        $(".closePopup").click();
        this.setState({ customermailid: "", whatsappNumber: "", mailid: "" });
      })
      .catch((error) => {
        toast.error(error.message || "An error occurred while sending mail.");
      });
  };

  sentWhatsappReport = async (e) => {
    const number = this.state.whatsappNumber;
    const userid = this.state.mailuserid;
    const arrythymia = this.state.arrythymia || "NA";

    if (!arrythymia || !number) {
      toast.error("Enter WhatsApp number to proceed");
      return;
    }

    var apiUrl = `${apiUrl}api/common/schedule_whatsapp`;

    var requestBody = {
      user_id: userid,
      arrythymia: arrythymia,
      number: number,
      scheduledTime: this.state.setCompletionDate,
    };

    fetch(apiUrl, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(requestBody),
    })
      .then((response) =>
        response.json().then((data) => {
          if (!response.ok)
            throw new Error(data.message || "Failed to send WhatsApp message.");
          return data;
        })
      )
      .then((data) => {
        toast.success("WhatsApp message sent successfully!");
        this.setState({
          customermailid: "",
          whatsappNumber: "",
          mailid: "",
          arrythymia: "",
        });
        $(".closePopup").click();
      })
      .catch((error) => {
        toast.error(
          error.message || "An error occurred while sending WhatsApp message."
        );
      });
  };
  sentMailReportPatient = async (e) => {
    const mailid = this.state.patientmailid;
    const userid = this.state.mailuserid;

    if (!userid || !mailid) {
      toast.error("Enter Email ID to proceed");
      return;
    }

    var apiUrl = `${apiUrl}api/users/sendmailReport_new_new_Read_Schedule`;

    var requestBody = {
      userid: userid,
      mailid: mailid,
      mailsubject:
        this.state.patientmailsubject ||
        `${this.state.patientName}: Biocalculus: ${this.state.device_id}`,
      scheduledTime: this.state.setCompletionDate, // Add scheduled time for patient
    };

    fetch(apiUrl, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(requestBody),
    })
      .then((response) =>
        response.json().then((data) => {
          if (!response.ok)
            throw new Error(data.message || "Failed to send email.");
          return data;
        })
      )
      .then((data) => {
        toast.success("Mail sent successfully!");
        $(".closePopup").click();
      })
      .catch((error) => {
        toast.error(error.message || "An error occurred while sending mail.");
      });
  };

  sentWhatsappReportPatient = async (e) => {
    const number = this.state.patientwhatsappNumber;
    const userid = this.state.mailuserid;
    const arrythymia = this.state.arrythymia || "NA";

    if (!arrythymia || !number) {
      toast.error("Enter WhatsApp number to proceed");
      return;
    }

    var apiUrl = `${apiUrl}api/common/schedule_whatsapp`;

    var requestBody = {
      user_id: userid,
      arrythymia: arrythymia,
      number: number,
      scheduledTime: this.state.setCompletionDate, // Add scheduled time for patient
    };

    fetch(apiUrl, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(requestBody),
    })
      .then((response) =>
        response.json().then((data) => {
          if (!response.ok)
            throw new Error(data.message || "Failed to send WhatsApp message.");
          return data;
        })
      )
      .then((data) => {
        toast.success("WhatsApp message sent successfully!");
      })
      .catch((error) => {
        toast.error(
          error.message || "An error occurred while sending WhatsApp message."
        );
      });
  };

  handleModalComplete(id) {
    // console.log("id:", id);
    this.state.userid = id;
    this.setState({ isModalCompleteOpen: true });
  }
  onSubmit = (e) => {
    e.preventDefault();

    const settings = {
      userid: this.state.userid,
      nor_minhr: this.state.nor_minhr,
      nor_maxhr: this.state.nor_maxhr,
      qtcformula: this.state.qtcformula,
      qtcvalue_min: this.state.qtcvalue_min,
      qtcvaluemax: this.state.qtcvaluemax,
      qrswidth_min: this.state.qrswidth_min,
      qrswidth_max: this.state.qrswidth_max,
      qrsamp_min: this.state.qrsamp_min,
      qrsamp_max: this.state.qrsamp_max,
      stelevation: this.state.stelevation,
      pwidth_min: this.state.pwidth_min,
      pwidth_max: this.state.pwidth_max,
      pamp_min: this.state.pamp_min,
      pamp_max: this.state.pamp_max,
      stdepression: this.state.stdepression,
      twidth_min: this.state.twidth_min,
      twidth_max: this.state.twidth_max,
      tamp_min: this.state.tamp_min,
      tamp_max: this.state.tamp_max,
      printerval_min: this.state.printerval_min,
      printerval_max: this.state.printerval_max,
      tachyhr_lower: this.state.tachyhr_lower,
      tachyhr_upper: this.state.tachyhr_upper,
      bradyhr_lower: this.state.bradyhr_lower,
      bradyhr_upper: this.state.bradyhr_upper,
      pauselength: this.state.pauselength,
      graph_gen: this.state.graph_gen,
    };

    // console.log(settings);
    axios
      .post(apiUrl + "api/patients/updateSettings", settings)
      .then((res) => {
        $("#closePopup").click();
        // console.log("onclick");
      })
      .catch((err) => {
        console.log(err);
      });
  };

  onSubmitInfo = (e) => {
    e.preventDefault();

    //   this.state.selectedVerifiers.forEach(verifier => {
    //     console.log("Verifier ID:", verifier.value);
    // });

    const info = {
      name: this.state.patient_name,
      patientid: this.state.userid,
      userid: this.state.userid,
      dob: this.state.dob,
      weight: this.state.weight,
      height: this.state.height,
      hospital: this.state.hospital,
      phone: this.state.phone,
      email: this.state.email_id,
      doctorid: this.state.selectedDoctor.value,
      ipop: this.state.ipop,
      fileType: this.state.filetype || "easy",
      verifierid: this.state.selectedVerifiers.map(
        (verifier) => verifier.value
      ),
      priority: this.state.priority,

      reportstatus: this.state.reportstatus,
      // smoking: this.state.smoking,
      // diabetes: this.state.diabetes,
      af: this.state.af,
      // hyper_tension: this.state.hyper_tension,
      // hyper_lipidemia: this.state.hyper_lipidemia,
      hyper_lipidemia: this.state.pacemaker,
      indication: this.state.indication,
      cardiac_surgery: this.state.cardiac_surgery,
      thyroid: this.state.thyroid_function,
      exp_device_use_days: this.state.duration,
      issueReported: this.state.issueReport,
      supportLevel: this.state.supportLevel,
      supportPerson: this.state.supportPerson,
      supportcomment: this.state.supportedMatter,
      prioritizeData: this.state.prioritizeData, // <-- Add this line
      clinicalCondition: this.state.clinicalCondition, // <-- Add this line
    };
    // console.log("info:", this.state.clinicalCondition);

    const deviceinfoupdate = {
      mac_id: this.state.macid,
      priority: this.state.priority,
    };

    axios
      .post(apiUrl + "api/patients/updateInfo_new_info_test", info)
      .then((res) => {
        // Handle the response of the first request
        // console.log("Patient info updated:", res.data);
        if (this.state.macid != null) {
          // If macid is either undefined or null
          return axios.put(
            `${apiUrl}api/patients/updateDevicePriority`,
            deviceinfoupdate
          );
        }
      })

      .then((res) => {
        // Handle the response of the second request
        // console.log("Device priority updated:", res.data);
        $(".closePopup").click();
        this.fetchData(); // Fetch updated data
      })
      .catch((err) => {
        // Handle any errors from either request
        console.error("Error occurred:", err);
      });
  };

  onChange = (e) => {
    var err = this.state.errors;
    delete err[e.target.name];
    // console.log("onChange");
    // console.log(e.target.name);
    // console.log(e.target.value);
    // console.log(e.target)
    // this.setState({reportstatus:e.target.value})
    // console.log(e.target.value)

    this.setState({ [e.target.name]: e.target.value });
  };
  onDurationChange = (e) => {
    var err = this.state.errors;
    delete err[e.target.name];
    this.setState({ duration: e.target.value });
    console.log(this.state.duration);
  };
  onPriorityChange = (e) => {
    var err = this.state.errors;
    delete err[e.target.name];

    this.setState({ priority: e.target.value });
    console.log(this.state.priority);
  };
  onReportStatuschange = (e) => {
    // console.log("report stats change",e.target.value)
    this.setState({ reportstatus: e.target.value });
  };

  preventDefault(e) {
    e.preventDefault();
  }

  getInfo(e) {
    this.setState({
      smoking: "",
      diabetes: "",
      af: "",
      hyper_tension: "",
      hyper_lipidemia: "",
      indication: "",
      cardiac_surgery: "",
      thyroid_function: "",
      loadingEditModal: true, // Set loading to true when starting
      supportPerson: "",
      supportLevel: "",
      supportedMatter: "",
    });
    this.setState({ isModalCompleteOpen: false });
    var userid = e.currentTarget.id;
    const dataid2 = e.target.getAttribute("dataid2");
    const dataid3 = e.target.getAttribute("dataid3");
    this.setState({ userid: userid });
    axios
      .get(`${apiUrl}api/patients/getPatinetAdditionalInfo?userid=${userid}`)
      .then((res) => {
        const data = res.data[0];
        if (
          data.gender === "MALE" ||
          data.gender === "male" ||
          data.gender === "Male" ||
          data.gender === "M" ||
          data.gender === "m"
        ) {
          this.setState({ gender: "M" });
        }

        if (
          data.gender === "FEMALE" ||
          data.gender === "female" ||
          data.gender === "Female" ||
          data.gender === "F" ||
          data.gender === "f"
        ) {
          this.setState({ gender: "F" });
        }
        if (data.gender === "Select Gender") {
          this.setState({ gender: "M" });
        }

        if (Array.isArray(this.state.patients)) {
          this.state.patients.forEach((patient) => {
            if (patient._id === userid) {
              this.setState({ reportstatus: patient.report_status });
              // console.log("report status", patient.report_status);
            }
          });
        }
        data.customer_details.forEach((customer) => {
          if (customer.customer_details) {
            // console.log('Nested Customer Details:', customer);
            this.setState({ customer_details: customer.customer_details });
          }
        });
        // console.log(this.state.patients);
        console.log("additional data!!!!!!!!!!!!!!!", data);
        // Update state with patient info
        this.setState({
          af: data.af ? "yes" : "no",
          duration: data.exp_device_use_days,
          cardiac_surgery: data.cardiac_surgery ? "yes" : "no",
          thyroid_function: data.thyroid,
          diabetes: data.diabetes,
          indication: data.indication,
          height: data.height,
          weight: data.weight,
          hospital: data.hospital,
          phone: data.phone,
          patient_name: data.name,
          email_id: data.email,
          selectedDoctor: { value: data.doctor_id, label: data.doctor_name },
          macid: dataid2,
          priority: dataid3,
          dob: data.dob,
          duration: data.exp_device_use_days,
          filetype: data.fileType,
          pacemaker: data.hyper_lipidemia,
          issueReport: data.issueReported,
          Confirmation: data.Confirmation,
          supportedMatter: data.supportcomment,
          supportPerson: data.supportPerson,
          supportLevel: data.supportLevel,
          prioritizeData: data.priorityStatus || "No",
          clinicalCondition: data.clinicalCondition || "", // <-- Add this line
        });
        // console.log("clinical condition:", data.clinicalCondition);
        // Handle DOB formatting
        let formattedDob = data.dob;
        if (formattedDob) {
          // Convert ISO string or YYYY-MM-DD to MM/DD/YYYY for display
          const dateObj = new Date(formattedDob);
          if (!isNaN(dateObj.getTime())) {
            const mm = String(dateObj.getMonth() + 1).padStart(2, "0");
            const dd = String(dateObj.getDate()).padStart(2, "0");
            const yyyy = dateObj.getFullYear();
            formattedDob = `${mm}/${dd}/${yyyy}`;
          }
        }
        this.setState({ dob: formattedDob });
        // console.log("Formatted DOB:", this.state.dob);

        // Second API call for verifiers
        return axios.get(`${apiUrl}api/users/allverifiers`);
      })
      .then((res) => {
        const verifiers = res.data;
        const formattedVerifiers = verifiers.map((verifier) => ({
          value: verifier._id,
          label: verifier.name,
          patients: verifier.patients, // Assuming patients is an array of user IDs
        }));

        const filteredVerifiers = formattedVerifiers.filter((verifier) =>
          verifier.patients.includes(userid)
        );

        // console.log('Filtered verifiers with matching user:', this.state.priority);

        this.setState({ selectedVerifiers: filteredVerifiers });

        this.setState({ verifiers: formattedVerifiers });
        // console.log('formatted verifiers:',verifiers)
        // Third API call for patient search (ipop)
        this.state.patients.forEach((patient) => {
          if (patient._id === userid) {
            this.setState({ comments: patient.comments });
            // this.setState({ priority: patient.priority });
            this.setState({ ipop: patient.ip_op });
          }
        });

        // console.log("ipop", this.state.patients);

        // Fourth API call for verified percentage
        return axios.get(`${apiUrl}api/users/getVerifiedPercentage/${userid}`);
      })
      .then((res) => {
        const ecgValues = res.data.ecgValues; // Assuming `ecgValues` is an array
        const totalLength = ecgValues.length;
        let verifyCount = 0; // Initialize verify count

        ecgValues.forEach((value, index) => {
          if (value.verifyStatus === 1) {
            // console.log(`Link for ECG value at index ${index}:`, value.link); // Assuming there's a 'link' property
            verifyCount++; // Increment the verify count
          }
        });

        // console.log('Total verified ECG values:', verifyCount);
        // console.log('Total count:', totalLength);

        if (totalLength > 0) {
          // console.log('ECG data is available.');

          // Calculate and log the percentage of verified ECG values
          const percentageVerified = (verifyCount / totalLength) * 100;
          // console.log('Percentage of verified ECG values:', percentageVerified.toFixed(2) + '%');
          this.setState({ percentageVerified: percentageVerified.toFixed(2) });
          // console.log('verified percentage:',this.state.percentageVerified)
        } else {
          // console.log('No ECG data found.');
        }
        this.setState({ loadingEditModal: false }); // Data loaded, hide spinner
        axios.get(`${apiUrl}api/common/getSupportPerson`).then((res) => {
          if (res.data && Array.isArray(res.data)) {
            this.setState({ supportPersons: res.data });
            // console.log("support persons:!!!!!!!!!!!!!!!!!!!!!!", this.state.supportPersons);
          }
        });
      })

      .catch((error) => {
        console.error("Error fetching ECG data:", error);
        this.setState({ loadingEditModal: false }); // Hide spinner on error
      });
  }

  selectItem(e) {
    var userid = e.currentTarget.id;
    this.setState({ userid: userid });
    this.setState({
      nor_minhr: "",
      nor_maxhr: "",
      qtcformula: "",
      qtcvalue_min: "",
      qtcvaluemax: "",
      qrswidth_min: "",
      qrswidth_max: "",
      qrsamp_min: "",
      qrsamp_max: "",
      stelevation: "",
      pwidth_min: "",
      pwidth_max: "",
      pamp_min: "",
      pamp_max: "",
      stdepression: "",
      twidth_min: "",
      twidth_max: "",
      tamp_min: "",
      tamp_max: "",
      printerval_min: "",
      printerval_max: "",
      tachyhr_lower: "",
      tachyhr_upper: "",
      bradyhr_lower: "",
      bradyhr_upper: "",
      pauselength: "",
      graph_gen: "",
    });
    axios
      .get(apiUrl + "api/patients/settings?userid=" + userid)
      .then((res) => {
        var data = res.data;
        this.setState(data);
      })
      .catch((err) => {
        console.log(err);
      });
  }
  resetInfoModal() {
    this.setState({
      smoking: "",
      diabetes: "",
      af: "",
      hyper_tension: "",
      hyper_lipidemia: "",
      indication: "",
      cardiac_surgery: "",
      thyroid_function: "",
      customer_details: "", // Reset customer details too
      reportstatus: "",
      dob: "",
      height: "",
      weight: "",
      hospital: "",
      phone: "",
      patient_name: "",
      email_id: "",
      doctor_name: "",
      doctor_id: "",
      duration: "",
      selectedVerifiers: [],
      verifiers: [],
      comments: "",
      priority: "",
      ipop: "",
      percentageVerified: "",
      selectedLabels: [],
    });
    // console.log(this.state.verifiers);
  }
  filterRows = () => {
    const { rows, searchQuery } = this.state;

    if (!searchQuery) {
      return rows; // If no search query, return all rows
    }

    return rows.filter((row) => {
      // You can modify this to check specific fields for a match
      return Object.values(row).some(
        (value) =>
          value &&
          value.toString().toLowerCase().includes(searchQuery.toLowerCase())
      );
    });
  };
  handleSearchChange = (e) => {
    this.setState({ searchQuery: e.target.value });
  };

  handlePageChange = (page) => {
    this.setState({ currentPage: page });
  };

  handleNextPage = () => {
    const totalPages = Math.ceil(
      this.filterRows().length / this.state.rowsPerPage
    );
    this.setState((prevState) => ({
      currentPage: Math.min(prevState.currentPage + 1, totalPages),
    }));
  };
  handlePrevPage = () => {
    this.setState((prevState) => ({
      currentPage: Math.max(prevState.currentPage - 1, 1),
    }));
  };
  handleRowClick(event) {
    const target = event.target;
    console.log("clicked!!!!!!!!!!!");
    // Check if the click happened on the specific columns (2, 3, or 4)
    if (target.closest("td:nth-child(2), td:nth-child(3), td:nth-child(4)")) {
      const row = target.closest("tr");
      const urlElement = row.querySelector(".patientLink");
      const url = urlElement ? urlElement.value : ""; // Avoid optional chaining

      // Check if a URL exists and navigate to it
      if (url && url.trim() !== "") {
        window.location.href = url;
      }
    }
  }
  handleToggle = (type) => {
    this.setState({ selectedType: type });
  };
  clearShareReportState = () => {
    this.setState({
      customermailid: "",
      whatsappNumber: "",
      mailid: "",
      arrythymia: "",
      patientmailid: "",
      patientwhatsappNumber: "",
      patientmailsubject: "",
      patientwhatsappMessage: "",
    });
  };

  render() {
    const { isConfirmationModalOpen, selectedConfirmation } = this.state;
    const { currentPage, rowsPerPage, dob } = this.state;
    const { columns, rows } = this.state;

    const totalPages = Math.ceil(this.filterRows().length / rowsPerPage);
    const startIndex = (currentPage - 1) * rowsPerPage;
    const displayedRows = this.filterRows().slice(
      startIndex,
      startIndex + rowsPerPage
    );

    // Pagination range logic (show up to 8 page numbers)
    const paginationNumbers = [];
    const startPage = Math.max(1, currentPage - 4);
    const endPage = Math.min(totalPages, startPage + 7);

    for (let i = startPage; i <= endPage; i++) {
      paginationNumbers.push(i);
    }
    const filteredRows = this.filterRows();
    if (localStorage.jwtToken == undefined) {
      window.location.href = "/";
    }
    const { errors, doctors, selectedDoctor } = this.state;
    const options = doctors.map((doctor) => ({
      value: doctor._id,
      label: doctor.name,
    }));

    let doctorsList =
      this.state.doctors.length > 0 &&
      this.state.doctors.map((item, i) => {
        return (
          <option
            key={i}
            value={item._id}
            selected={this.state.doctor_name == item.name}
          >
            {item.name}
          </option>
        );
      }, this);

    return (
      <div className="wrapper theme-6-active box-layout pimary-color-green">
        <Toaster position="top-right" reverseOrder={false} />
        <TopNav profileLink={this.state.profileLink} />
        <AddModalComplete
          userid={this.state.userid}
          isOpen={this.state.isModalCompleteOpen}
        />

        <SideBar menus={this.state.menus} />
        <div className="right-sidebar-backdrop"></div>
        <div className="page-wrapper" style={{ marginTop: "30px", background: "#06191a", minHeight: "100vh" }}>
          <div className="container-fluid">
            <div id="myModalDHome" className="modal fade" role="dialog">
              <div className="modal-dialog">
                <div className="modal-content">
                  <div className="modal-header">
                    <button
                      type="button"
                      className="close"
                      data-dismiss="modal"
                    >
                      &times;
                    </button>
                    <h4 className="modal-title text-center">
                      General Settings
                    </h4>
                  </div>
                  <form method="post" onSubmit={this.onSubmit}>
                    <div className="modal-body">
                      <div className="row row-sm-offset">
                        <br />
                        <div className="col-md-4 multi-horizontal">
                          <div className="form-group">
                            <label
                              className="form-control-label mbr-fonts-style display-7"
                              style={{ color: "Black" }}
                            >
                              Normal Heart Rate Min
                            </label>
                            <input
                              type="text"
                              className={classnames("form-control", {
                                errors: errors.nor_minhr,
                              })}
                              name="nor_minhr"
                              required=""
                              id="nor_minhr"
                              onChange={this.onChange}
                              value={this.state.nor_minhr}
                            />
                          </div>
                        </div>
                        <div className="col-md-4 multi-horizontal">
                          <div className="form-group">
                            <label
                              className="form-control-label mbr-fonts-style display-7"
                              style={{ color: "Black" }}
                            >
                              Normal Heart Rate Max
                            </label>
                            <input
                              type="text"
                              className={classnames("form-control", {
                                errors: errors.nor_maxhr,
                              })}
                              name="nor_maxhr"
                              required=""
                              id="nor_maxhr"
                              onChange={this.onChange}
                              value={this.state.nor_maxhr}
                            />
                          </div>
                        </div>
                        <div className="col-md-4 multi-horizontal">
                          <div className="form-group">
                            <label
                              className="form-control-label mbr-fonts-style display-7"
                              style={{ color: "Black" }}
                            >
                              QTC Formula
                            </label>
                            <select
                              name="qtcformula"
                              className={classnames("form-control", {
                                errors: errors.qtcformula,
                              })}
                              value={this.state.qtcformula}
                              onChange={this.onChange}
                            >
                              <option value="Bazett">Bazett </option>
                              <option value="Fridericia">Fridericia</option>
                              <option value="Framingham">Framingham</option>
                              <option value="Hodges">Hodges</option>
                            </select>
                          </div>
                        </div>
                      </div>
                      <div className="row row-sm-offset">
                        <br />
                        <div className="col-md-4 multi-horizontal">
                          <div className="form-group">
                            <label
                              className="form-control-label mbr-fonts-style display-7"
                              style={{ color: "Black" }}
                            >
                              QTC Value Min
                            </label>
                            <input
                              type="text"
                              className={classnames("form-control", {
                                errors: errors.qtcvalue_min,
                              })}
                              name="qtcvalue_min"
                              required=""
                              id="qtcvalue_min"
                              onChange={this.onChange}
                              value={this.state.qtcvalue_min}
                            />
                          </div>
                        </div>
                        <div className="col-md-4 multi-horizontal">
                          <div className="form-group">
                            <label
                              className="form-control-label mbr-fonts-style display-7"
                              style={{ color: "Black" }}
                            >
                              QTC Value Max
                            </label>
                            <input
                              type="text"
                              className={classnames("form-control", {
                                errors: errors.qtcvaluemax,
                              })}
                              name="qtcvaluemax"
                              required=""
                              id="qtcvaluemax"
                              onChange={this.onChange}
                              value={this.state.qtcvaluemax}
                            />
                          </div>
                        </div>
                        <div className="col-md-4 multi-horizontal">
                          <div className="form-group">
                            <label
                              className="form-control-label mbr-fonts-style display-7"
                              style={{ color: "Black" }}
                            >
                              QRS Width Min(ms){" "}
                            </label>
                            <input
                              type="text"
                              className={classnames("form-control", {
                                errors: errors.qrswidth_min,
                              })}
                              name="qrswidth_min"
                              required=""
                              id="qrswidth_min"
                              onChange={this.onChange}
                              value={this.state.qrswidth_min}
                            />
                          </div>
                        </div>
                      </div>
                      <div className="row row-sm-offset">
                        <div className="col-md-4 multi-horizontal">
                          <div className="form-group">
                            <label
                              className="form-control-label mbr-fonts-style display-7"
                              style={{ color: "Black" }}
                            >
                              QRS Width Max (ms){" "}
                            </label>
                            <input
                              type="text"
                              className={classnames("form-control", {
                                errors: errors.qrswidth_max,
                              })}
                              name="qrswidth_max"
                              required=""
                              id="qrswidth_max"
                              onChange={this.onChange}
                              value={this.state.qrswidth_max}
                            />
                          </div>
                        </div>
                        <div className="col-md-4 multi-horizontal">
                          <div className="form-group">
                            <label
                              className="form-control-label mbr-fonts-style display-7"
                              style={{ color: "Black" }}
                            >
                              QRS Amplitude Min (mv)
                            </label>
                            <input
                              type="text"
                              className={classnames("form-control", {
                                errors: errors.qrsamp_min,
                              })}
                              name="qrsamp_min"
                              required=""
                              id="qrsamp_min"
                              onChange={this.onChange}
                              value={this.state.qrsamp_min}
                            />
                          </div>
                        </div>
                        <div className="col-md-4 multi-horizontal">
                          <div className="form-group">
                            <label
                              className="form-control-label mbr-fonts-style display-7"
                              style={{ color: "Black" }}
                            >
                              QRS Amplitude Max (mv)
                            </label>
                            <input
                              type="text"
                              className={classnames("form-control", {
                                errors: errors.qrsamp_max,
                              })}
                              name="qrsamp_max"
                              required=""
                              id="qrsamp_max"
                              onChange={this.onChange}
                              value={this.state.qrsamp_max}
                            />
                          </div>
                        </div>
                      </div>
                      <div className="row row-sm-offset">
                        <div className="col-md-4 multi-horizontal">
                          <div className="form-group">
                            <label
                              className="form-control-label mbr-fonts-style display-7"
                              style={{ color: "Black" }}
                            >
                              ST Elevation (mm)
                            </label>
                            <input
                              type="text"
                              className={classnames("form-control", {
                                errors: errors.stelevation,
                              })}
                              name="stelevation"
                              required=""
                              id="stelevation"
                              onChange={this.onChange}
                              value={this.state.stelevation}
                            />
                          </div>
                        </div>
                        <div className="col-md-4 multi-horizontal">
                          <div className="form-group">
                            <label
                              className="form-control-label mbr-fonts-style display-7"
                              style={{ color: "Black" }}
                            >
                              P Width Min (ms)
                            </label>
                            <input
                              type="text"
                              className={classnames("form-control", {
                                errors: errors.pwidth_min,
                              })}
                              name="pwidth_min"
                              required=""
                              id="pwidth_min"
                              onChange={this.onChange}
                              value={this.state.pwidth_min}
                            />
                          </div>
                        </div>
                        <div className="col-md-4 multi-horizontal">
                          <div className="form-group">
                            <label
                              className="form-control-label mbr-fonts-style display-7"
                              style={{ color: "Black" }}
                            >
                              P Width Max (ms)
                            </label>
                            <input
                              type="text"
                              className={classnames("form-control", {
                                errors: errors.pwidth_max,
                              })}
                              name="pwidth_max"
                              required=""
                              id="pwidth_max"
                              onChange={this.onChange}
                              value={this.state.pwidth_max}
                            />
                          </div>
                        </div>
                      </div>
                      <div className="row row-sm-offset">
                        <div className="col-md-4 multi-horizontal">
                          <div className="form-group">
                            <label
                              className="form-control-label mbr-fonts-style display-7"
                              style={{ color: "Black" }}
                            >
                              P Amplitude Min (mv)
                            </label>
                            <input
                              type="text"
                              className={classnames("form-control", {
                                errors: errors.pamp_min,
                              })}
                              name="pamp_min"
                              required=""
                              id="pamp_min"
                              onChange={this.onChange}
                              value={this.state.pamp_min}
                            />
                          </div>
                        </div>
                        <div className="col-md-4 multi-horizontal">
                          <div className="form-group">
                            <label
                              className="form-control-label mbr-fonts-style display-7"
                              style={{ color: "Black" }}
                            >
                              P Amplitude Max (mv)
                            </label>
                            <input
                              type="text"
                              className={classnames("form-control", {
                                errors: errors.pamp_max,
                              })}
                              name="pamp_max"
                              required=""
                              id="pamp_max"
                              onChange={this.onChange}
                              value={this.state.pamp_max}
                            />
                          </div>
                        </div>
                        <div className="col-md-4 multi-horizontal">
                          <div className="form-group">
                            <label
                              className="form-control-label mbr-fonts-style display-7"
                              style={{ color: "Black" }}
                            >
                              T Width Min (ms){" "}
                            </label>
                            <input
                              type="text"
                              className={classnames("form-control", {
                                errors: errors.twidth_min,
                              })}
                              name="twidth_min"
                              required=""
                              id="twidth_min"
                              onChange={this.onChange}
                              value={this.state.twidth_min}
                            />
                          </div>
                        </div>
                      </div>
                      <div className="row row-sm-offset">
                        <div className="col-md-4 multi-horizontal">
                          <div className="form-group">
                            <label
                              className="form-control-label mbr-fonts-style display-7"
                              style={{ color: "Black" }}
                            >
                              T Width Max (ms)
                            </label>
                            <input
                              type="text"
                              className={classnames("form-control", {
                                errors: errors.twidth_max,
                              })}
                              name="twidth_max"
                              required=""
                              id="twidth_max"
                              onChange={this.onChange}
                              value={this.state.twidth_max}
                            />
                          </div>
                        </div>
                        <div className="col-md-4 multi-horizontal">
                          <div className="form-group">
                            <label
                              className="form-control-label mbr-fonts-style display-7"
                              style={{ color: "Black" }}
                            >
                              T Amplitude Min (mv)
                            </label>
                            <input
                              type="text"
                              className={classnames("form-control", {
                                errors: errors.tamp_min,
                              })}
                              name="tamp_min"
                              required=""
                              id="tamp_min"
                              onChange={this.onChange}
                              value={this.state.tamp_min}
                            />
                          </div>
                        </div>
                        <div className="col-md-4 multi-horizontal">
                          <div className="form-group">
                            <label
                              className="form-control-label mbr-fonts-style display-7"
                              style={{ color: "Black" }}
                            >
                              T Amplitude Max (mv)
                            </label>
                            <input
                              type="text"
                              className={classnames("form-control", {
                                errors: errors.tamp_max,
                              })}
                              name="tamp_max"
                              required=""
                              id="tamp_max"
                              onChange={this.onChange}
                              value={this.state.tamp_max}
                            />
                          </div>
                        </div>
                      </div>
                      <div className="row row-sm-offset">
                        <div className="col-md-4 multi-horizontal">
                          <div className="form-group">
                            <label
                              className="form-control-label mbr-fonts-style display-7"
                              style={{ color: "Black" }}
                            >
                              PR Interval Min{" "}
                            </label>
                            <input
                              type="text"
                              className={classnames("form-control", {
                                errors: errors.printerval_min,
                              })}
                              name="printerval_min"
                              required=""
                              id="printerval_min"
                              onChange={this.onChange}
                              value={this.state.printerval_min}
                            />
                          </div>
                        </div>
                        <div className="col-md-4 multi-horizontal">
                          <div className="form-group">
                            <label
                              className="form-control-label mbr-fonts-style display-7"
                              style={{ color: "Black" }}
                            >
                              PR Interval Max{" "}
                            </label>
                            <input
                              type="text"
                              className={classnames("form-control", {
                                errors: errors.printerval_max,
                              })}
                              name="printerval_max"
                              required=""
                              id="printerval_max"
                              onChange={this.onChange}
                              value={this.state.printerval_max}
                            />
                          </div>
                        </div>
                        <div className="col-md-4 multi-horizontal">
                          <div className="form-group">
                            <label
                              className="form-control-label mbr-fonts-style display-7"
                              style={{ color: "Black" }}
                            >
                              Tachy Lower Limit{" "}
                            </label>
                            <input
                              type="text"
                              className={classnames("form-control", {
                                errors: errors.tachyhr_lower,
                              })}
                              name="tachyhr_lower"
                              required=""
                              id="tachyhr_lower"
                              onChange={this.onChange}
                              value={this.state.tachyhr_lower}
                            />
                          </div>
                        </div>
                      </div>
                      <div className="row row-sm-offset">
                        <div className="col-md-4 multi-horizontal">
                          <div className="form-group">
                            <label
                              className="form-control-label mbr-fonts-style display-7"
                              style={{ color: "Black" }}
                            >
                              Tachy Upper Limit{" "}
                            </label>
                            <input
                              type="text"
                              className={classnames("form-control", {
                                errors: errors.tachyhr_upper,
                              })}
                              name="tachyhr_upper"
                              required=""
                              id="tachyhr_upper"
                              onChange={this.onChange}
                              value={this.state.tachyhr_upper}
                            />
                          </div>
                        </div>
                        <div className="col-md-4 multi-horizontal">
                          <div className="form-group">
                            <label
                              className="form-control-label mbr-fonts-style display-7"
                              style={{ color: "Black" }}
                            >
                              Brady Lower Limit{" "}
                            </label>
                            <input
                              type="text"
                              className={classnames("form-control", {
                                errors: errors.bradyhr_lower,
                              })}
                              name="bradyhr_lower"
                              required=""
                              id="bradyhr_lower"
                              onChange={this.onChange}
                              value={this.state.bradyhr_lower}
                            />
                          </div>
                        </div>
                        <div className="col-md-4 multi-horizontal">
                          <div className="form-group">
                            <label
                              className="form-control-label mbr-fonts-style display-7"
                              style={{ color: "Black" }}
                            >
                              Brady Upper Limit{" "}
                            </label>
                            <input
                              type="text"
                              className={classnames("form-control", {
                                errors: errors.bradyhr_upper,
                              })}
                              name="bradyhr_upper"
                              required=""
                              id="bradyhr_upper"
                              onChange={this.onChange}
                              value={this.state.bradyhr_upper}
                            />
                          </div>
                        </div>
                      </div>
                      <div className="row row-sm-offset">
                        <div className="col-md-4 multi-horizontal">
                          <div className="form-group">
                            <label
                              className="form-control-label mbr-fonts-style display-7"
                              style={{ color: "Black" }}
                            >
                              ST Depression (mm)
                            </label>
                            <input
                              type="text"
                              className={classnames("form-control", {
                                errors: errors.stdepression,
                              })}
                              name="stdepression"
                              required=""
                              id="stdepression"
                              onChange={this.onChange}
                              value={this.state.stdepression}
                            />
                          </div>
                        </div>
                        <div className="col-md-4 multi-horizontal">
                          <div className="form-group">
                            <label
                              className="form-control-label mbr-fonts-style display-7"
                              style={{ color: "Black" }}
                            >
                              Pause Length (s){" "}
                            </label>
                            <input
                              type="text"
                              className={classnames("form-control", {
                                errors: errors.pauselength,
                              })}
                              name="pauselength"
                              required=""
                              id="pauselength"
                              onChange={this.onChange}
                              value={this.state.pauselength}
                            />
                          </div>
                        </div>
                        <div className="col-md-4 multi-horizontal">
                          <div className="form-group">
                            <label
                              className="form-control-label mbr-fonts-style display-7"
                              style={{ color: "Black" }}
                            >
                              Graphs To Be Generated(no:){" "}
                            </label>
                            <input
                              type="text"
                              className={classnames("form-control", {
                                errors: errors.graph_gen,
                              })}
                              name="graph_gen"
                              required=""
                              id="graph_gen"
                              onChange={this.onChange}
                              value={this.state.graph_gen}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="modal-footer">
                      <button
                        type="submit"
                        className="btn btn-success"
                        style={{ color: "Black" }}
                      >
                        Submit
                      </button>
                      {
                        <button
                          id="closePopup"
                          type="button"
                          className="btn btn-default closePopup"
                          data-dismiss="modal"
                          style={{ color: "Black" }}
                        >
                          Close
                        </button>
                      }
                    </div>
                  </form>
                </div>
              </div>
            </div>
            {/* ── Comments Modal ── */}
            <div id="commentinfomodal" className="modal fade" role="dialog" aria-hidden="true">
              <div className="modal-dialog" style={{ maxWidth: 580, margin: "50px auto", width: "90%" }}>
                <div className="modal-content" style={{ borderRadius: 10, overflow: "hidden", border: "none", boxShadow: "0 12px 40px rgba(0,0,0,0.4)" }}>

                  {/* Header */}
                  <div style={{ background: "#1e2d38", padding: "12px 18px", display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                    <div>
                      <div style={{ color: "#fff", fontWeight: 700, fontSize: "15px", display: "flex", alignItems: "center", gap: 6 }}>
                        💬 Comments
                      </div>
                      {this.state.patient_name && (
                        <div style={{ color: "#89c4e1", fontSize: "12px", marginTop: 2 }}>
                          {this.state.patient_name}
                        </div>
                      )}
                    </div>
                    <button type="button" data-dismiss="modal" className="closePopup"
                      style={{ background: "rgba(255,255,255,0.1)", border: "none", color: "#fff", width: 28, height: 28, borderRadius: "50%", fontSize: "16px", lineHeight: 1, cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "center" }}>
                      ×
                    </button>
                  </div>

                  {/* Comment History */}
                  {(() => {
                    const raw = (this.state.comments || "").trim();
                    const lines = raw ? raw.split("\n").filter(l => l.trim()) : [];
                    return (
                      <div style={{ background: "#f5f7fa", borderBottom: "1px solid #e2e8f0", maxHeight: 280, overflowY: "auto", padding: lines.length ? "12px 16px" : "0" }}>
                        {lines.length === 0 ? (
                          <div style={{ padding: "18px 16px", textAlign: "center", color: "#aaa", fontSize: "13px" }}>No comments yet</div>
                        ) : (
                          lines.map((line, idx) => {
                            const byMatch = line.match(/^(.*?)\s*[—–-]+\s*BY\s+(.+?)(?:\s*\[(.+?)\])?$/i)
                                         || line.match(/^(.*?)\s*—\s*(.+?)(?:\s*\[(.+?)\])?$/);
                            const text   = byMatch ? byMatch[1].trim() : line;
                            const author = byMatch ? byMatch[2].trim() : "";
                            const time   = byMatch ? byMatch[3] || "" : "";
                            const initials = author ? author.split(" ").map(w => w[0]).join("").slice(0,2).toUpperCase() : "?";
                            const colors = ["#3498db","#9b59b6","#1abc9c","#e67e22","#e74c3c","#2ecc71"];
                            const avatarColor = colors[initials.charCodeAt(0) % colors.length];
                            return (
                              <div key={idx} style={{ display: "flex", gap: 10, marginBottom: idx < lines.length - 1 ? 12 : 0 }}>
                                <div style={{ width: 32, height: 32, borderRadius: "50%", background: avatarColor, color: "#fff", display: "flex", alignItems: "center", justifyContent: "center", fontSize: "11px", fontWeight: 700, flexShrink: 0, marginTop: 2 }}>
                                  {initials}
                                </div>
                                <div style={{ flex: 1 }}>
                                  <div style={{ background: "#fff", border: "1px solid #e2e8f0", borderRadius: "0 8px 8px 8px", padding: "8px 12px", fontSize: "13px", color: "#2d3748", lineHeight: 1.5, boxShadow: "0 1px 3px rgba(0,0,0,0.06)" }}>
                                    {text}
                                  </div>
                                  <div style={{ fontSize: "11px", color: "#94a3b8", marginTop: 3, paddingLeft: 2 }}>
                                    <span style={{ fontWeight: 600, color: "#64748b" }}>{author || "Unknown"}</span>
                                    {time && <span style={{ marginLeft: 6 }}>{time}</span>}
                                  </div>
                                </div>
                              </div>
                            );
                          })
                        )}
                      </div>
                    );
                  })()}

                  {/* New Comment Input */}
                  <div style={{ background: "#fff", padding: "14px 16px 10px" }}>
                    <div style={{ fontSize: "11px", fontWeight: 600, color: "#64748b", textTransform: "uppercase", letterSpacing: "0.5px", marginBottom: 8 }}>Add New Comment</div>
                    <textarea
                      value={this.state.newComment || ""}
                      onChange={(e) => this.setState({ newComment: e.target.value })}
                      placeholder="Type your observation, finding or note here…"
                      maxLength={300}
                      rows={3}
                      style={{ width: "100%", fontSize: "13px", color: "#2d3748", border: "1px solid #cbd5e0", borderRadius: 6, padding: "10px 12px", resize: "none", outline: "none", fontFamily: "inherit", lineHeight: 1.6 }}
                      onFocus={e => e.target.style.borderColor = "#4299e1"}
                      onBlur={e => e.target.style.borderColor = "#cbd5e0"}
                    />
                    <div style={{ textAlign: "right", fontSize: "11px", color: (this.state.newComment || "").length > 250 ? "#e74c3c" : "#94a3b8", marginTop: 3 }}>
                      {(this.state.newComment || "").length}/300
                    </div>
                  </div>

                  {/* Footer */}
                  <div style={{ padding: "8px 16px 14px", background: "#fff", display: "flex", justifyContent: "flex-end", gap: 8, borderTop: "1px solid #f0f0f0" }}>
                    <button type="button" data-dismiss="modal" className="closePopup"
                      style={{ padding: "7px 20px", fontSize: "13px", background: "#f8fafc", border: "1px solid #e2e8f0", borderRadius: 6, color: "#555", cursor: "pointer", fontWeight: 500 }}>
                      Cancel
                    </button>
                    <button id={this.state.userid} type="button" onClick={this.submitComment}
                      disabled={!(this.state.newComment || "").trim()}
                      style={{ padding: "7px 22px", fontSize: "13px", background: (this.state.newComment || "").trim() ? "#1e8449" : "#a8d5b5", border: "none", borderRadius: 6, color: "#fff", fontWeight: 700, cursor: (this.state.newComment || "").trim() ? "pointer" : "not-allowed" }}>
                      ✓ Add Comment
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div
              id="mailinfomodal"
              className="modal fade"
              role="dialog"
              aria-labelledby="mailinfomodal"
              aria-hidden="true"
              onClick={(e) => {
                if (
                  e.target.className.includes("close") ||
                  e.target.className.includes("btn-default")
                ) {
                  this.clearShareReportState();
                }
              }}
            >
              <div className="modal-dialog">
                <div className="modal-content">
                  <div className="modal-header">
                    <button
                      type="button"
                      className="close"
                      data-dismiss="modal"
                      aria-label="Close"
                      onClick={this.clearShareReportState}
                    >
                      <span aria-hidden="true">&times;</span>
                    </button>
                    <h4 className="modal-title text-center">Share Report</h4>
                  </div>

                  <div className="modal-body">
                    {/* Switch Selector for Customer/Patient */}
                    <div className="switch-container">
                      <div
                        className={`switch-option ${
                          this.state.selectedType === "customer" ? "active" : ""
                        }`}
                        onClick={() =>
                          this.setState({ selectedType: "customer" })
                        }
                      >
                        Customer
                      </div>
                      <div
                        className={`switch-option ${
                          this.state.selectedType === "patient" ? "active" : ""
                        }`}
                        onClick={() =>
                          this.setState({ selectedType: "patient" })
                        }
                      >
                        Patient
                      </div>
                    </div>

                    {/* Dynamic Form Section */}
                    {this.state.selectedType === "customer" ? (
                      <>
                        {/* Mail Report Section */}
                        <div className="mail-section">
                          <h5>Mail Report (Customer):</h5>
                          <input
                            value={this.state.customermailid}
                            style={{ width: "100%", marginBottom: "10px" }}
                            placeholder="Enter customer email..."
                            onChange={(e) =>
                              this.setState({ customermailid: e.target.value })
                            }
                          />
                          <textarea
                            onChange={(e) =>
                              this.setState({ mailsubject: e.target.value })
                            }
                            value={this.state.mailsubject}
                            placeholder="Enter email subject..."
                            style={{ width: "100%", height: "80px" }}
                          />
                        </div>

                        <hr />

                        {/* WhatsApp Report Section */}
                        <div className="whatsapp-section">
                          <h5>WhatsApp Report (Customer):</h5>
                          <input
                            value={this.state.whatsappNumber}
                            style={{ width: "100%", marginBottom: "10px" }}
                            placeholder="Enter customer WhatsApp number..."
                            onChange={(e) =>
                              this.setState({ whatsappNumber: e.target.value })
                            }
                          />
                          <textarea
                            onChange={(e) =>
                              this.setState({ arrythymia: e.target.value })
                            }
                            value={this.state.whatsappMessage}
                            placeholder="Enter WhatsApp message..."
                            style={{ width: "100%", height: "80px" }}
                          />
                        </div>

                        {/* New field for scheduling mail */}
                        <input
                          type="datetime-local"
                          value={this.state.setCompletionDate}
                          style={{ width: "100%", marginBottom: "10px" }}
                          onChange={(e) =>
                            this.setState({ setCompletionDate: e.target.value })
                          }
                          onClick={() =>
                            this.setState({
                              setCompletionDate: this.getCurrentDateTime(),
                            })
                          } // Set current date & time when clicked
                        />
                      </>
                    ) : (
                      <>
                        {/* Mail Report Section for Patient */}
                        <div className="mail-section">
                          <h5>Mail Report (Patient):</h5>
                          <input
                            value={this.state.patientmailid}
                            style={{ width: "100%", marginBottom: "10px" }}
                            placeholder="Enter patient email..."
                            onChange={(e) =>
                              this.setState({ patientmailid: e.target.value })
                            }
                          />
                          <textarea
                            onChange={(e) =>
                              this.setState({
                                patientmailsubject: e.target.value,
                              })
                            }
                            value={this.state.patientmailsubject}
                            placeholder="Enter email subject..."
                            style={{ width: "100%", height: "80px" }}
                          />
                        </div>

                        <hr />

                        {/* WhatsApp Report Section for Patient */}
                        <div className="whatsapp-section">
                          <h5>WhatsApp Report (Patient):</h5>
                          <input
                            value={this.state.patientwhatsappNumber}
                            style={{ width: "100%", marginBottom: "10px" }}
                            placeholder="Enter patient WhatsApp number..."
                            onChange={(e) =>
                              this.setState({
                                patientwhatsappNumber: e.target.value,
                              })
                            }
                          />
                          <textarea
                            onChange={(e) =>
                              this.setState({ arrythymia: e.target.value })
                            }
                            value={this.state.arrythymia}
                            placeholder="Enter WhatsApp message..."
                            style={{ width: "100%", height: "80px" }}
                          />
                        </div>

                        {/* New field for scheduling mail */}
                        <input
                          type="datetime-local"
                          value={this.state.setCompletionDate}
                          style={{ width: "100%", marginBottom: "10px" }}
                          onChange={(e) =>
                            this.setState({ setCompletionDate: e.target.value })
                          }
                          onClick={() =>
                            this.setState({
                              setCompletionDate: this.getCurrentDateTime(),
                            })
                          } // Set current date & time when clicked
                        />
                      </>
                    )}
                  </div>

                  <div className="modal-footer">
                    <button
                      type="submit"
                      className="btn btn-success"
                      data-dismiss="modal"
                      onClick={() => {
                        if (this.state.selectedType === "customer") {
                          this.sentMailReport();
                          this.sentWhatsappReport();
                        } else {
                          this.sentMailReportPatient();
                          this.sentWhatsappReportPatient();
                        }
                        this.clearShareReportState();
                      }}
                    >
                      Submit
                    </button>
                    <button
                      type="button"
                      className="btn btn-default"
                      data-dismiss="modal"
                      onClick={this.clearShareReportState}
                    >
                      Close
                    </button>
                  </div>
                </div>
              </div>
            </div>

            <div
              id="whatsappinfomodal"
              className="modal fade"
              role="dialog"
              aria-labelledby="whatsappinfomodal"
              aria-hidden="true"
            >
              <div className="modal-dialog">
                <div className="modal-content">
                  <div className="modal-header">
                    <button
                      type="button"
                      className="close"
                      data-dismiss="modal"
                      aria-label="Close"
                    >
                      <span aria-hidden="true">&times;</span>
                    </button>
                    <h4
                      className="modal-title text-center"
                      id="whatsappinfomodal"
                    >
                      Share Report Via Whatsapp
                    </h4>
                  </div>

                  <div className="modal-body">
                    <input
                      value={this.state.whatsappNumber || ""} // Default to empty string if comments is undefined
                      style={{ width: "100%", color: "black" }}
                      placeholder="Enter whatsapp to share report....."
                      onChange={(e) =>
                        this.setState({ whatsappNumber: e.target.value })
                      } // Update comments directly in state
                    />
                    <textarea
                      onChange={(e) => {
                        const value = e.target.value; // Get the current value
                        console.log("Typing value:", value); // Log the value to the console
                        this.setState({ arrythymia: value }); // Update state
                      }}
                      // value={this.state.mailsubject} // Bind to the dynamic state
                      placeholder="Enter Report Subject Here..."
                      className="subject-textarea"
                    />
                  </div>
                  <div className="modal-footer">
                    <div className="row row-sm-offset">
                      <div className="col-md-6 multi-horizontal">
                        <button
                          id={this.state.userid}
                          type="submit"
                          className="btn btn-success"
                          style={{ color: "Black" }}
                          onClick={this.sentWhatsappReport}
                        >
                          Submit
                        </button>
                      </div>
                      <div className="col-md-6 multi-horizontal text-left">
                        <button
                          type="button"
                          className="btn btn-default closePopup"
                          data-dismiss="modal"
                        >
                          Close
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div
              id="editInfoModal"
              className="modal fade"
              role="dialog"
              data-backdrop="static"
              data-keyboard="false"
            >
              <div className="modal-dialog modal-lg">
                <div className="modal-content">
                  <div className="modal-header">
                    <button
                      type="button"
                      className="close"
                      data-dismiss="modal"
                      onClick={this.resetInfoModal.bind(this)}
                    >
                      &times;
                    </button>
                    <h4 className="modal-title text-center">
                      Edit Patient Information
                    </h4>
                  </div>

                  <form method="post" onSubmit={this.onSubmitInfo}>
                    <div
                      className="modal-body"
                      style={{ position: "relative" }}
                    >
                      {/* Full-modal loading overlay */}
                      {this.state.loadingEditModal && (
                        <div
                          className="modal-loading-overlay"
                          style={{
                            position: "absolute",
                            top: 0,
                            left: 0,
                            width: "100%",
                            height: "100%",
                            background: "rgba(255,255,255,0.7)",
                            zIndex: 10,
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                          }}
                        >
                          <div
                            className="spinner-edit-modal"
                            style={{
                              width: 48,
                              height: 48,
                              border: "6px solid #f3f3f3",
                              borderTop: "6px solid #3498db",
                              borderRadius: "50%",
                              animation: "spin 1s linear infinite",
                            }}
                          ></div>
                          <style>{`@keyframes spin { 
                0% { transform: rotate(0deg); } 
                100% { transform: rotate(360deg); } 
              }`}</style>
                        </div>
                      )}

                      {/* Row 1: Name, Email, Phone */}
                      <div className="row">
                        <div className="col-md-4">
                          <div className="form-group">
                            <label style={{ color: "Black" }}>Name</label>
                            <input
                              type="text"
                              className="form-control"
                              name="patient_name"
                              onChange={this.onChange}
                              value={this.state.patient_name}
                            />
                          </div>
                        </div>

                        <div className="col-md-4">
                          <div className="form-group">
                            <label style={{ color: "Black" }}>Email</label>
                            <input
                              type="text"
                              className="form-control"
                              name="email_id"
                              onChange={this.onChange}
                              value={this.state.email_id}
                            />
                          </div>
                        </div>

                        <div className="col-md-4">
                          <div className="form-group">
                            <label style={{ color: "Black" }}>Phone</label>
                            <input
                              type="text"
                              className="form-control"
                              name="phone"
                              onChange={this.onChange}
                              value={this.state.phone}
                            />
                          </div>
                        </div>
                      </div>

                      {/* Row 2: Doctor Name, Hospital, IP/OP */}
                      <div className="row">
                        <div className="col-md-4">
                          <div className="form-group">
                            <label style={{ color: "Black" }}>
                              Hospital Name
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              name="hospital"
                              onChange={this.onChange}
                              value={this.state.hospital}
                            />
                          </div>
                        </div>

                        <div className="col-md-4">
                          <div className="form-group">
                            <label style={{ color: "Black" }}>
                              Doctor Name
                            </label>
                            <Select
                              options={options}
                              value={selectedDoctor}
                              onChange={this.handleDoctorChange}
                              placeholder="Search Doctor"
                              classNamePrefix="react-select"
                              styles={{
                                control: (base) => ({
                                  ...base,
                                  borderColor: errors.doctor_id
                                    ? "red"
                                    : base.borderColor,
                                }),
                              }}
                            />
                          </div>
                        </div>

                        <div className="col-md-4">
                          <div className="form-group">
                            <label style={{ color: "Black" }}>IP/OP</label>
                            <input
                              type="text"
                              className="form-control"
                              onChange={this.onIpOpChange}
                              value={this.state.ipop}
                            />
                          </div>
                        </div>
                      </div>

                      {/* Row 3: DOB + File Type + Confirmation */}
                      <div className="row">
                        {/* DOB */}
                        <div className="col-md-4">
                          <div className="form-group">
                            <label style={{ color: "Black" }}>DOB</label>
                            <div className="input-group">
                              <Datetime
                                value={dob}
                                onChange={this.handleDateChange}
                                inputProps={{
                                  className: `form-control ${
                                    errors.dob ? "is-invalid" : ""
                                  }`,
                                  placeholder: "Select Date",
                                }}
                                dateFormat="MM/DD/YYYY"
                                timeFormat={false}
                              />
                              <span className="input-group-addon">
                                <span className="fa fa-calendar"></span>
                              </span>
                            </div>
                            {errors.dob && (
                              <div className="invalid-feedback">
                                {errors.dob}
                              </div>
                            )}
                          </div>
                        </div>

                        {/* File Type */}
                        <div className="col-md-4">
                          <div className="form-group">
                            <label style={{ color: "Black" }}>File Type</label>
                            <select
                              className="form-control"
                              value={this.state.filetype}
                              onChange={this.handleTypeChange}
                            >
                              <option value="easy">Easy</option>
                              <option value="moderate">Moderate</option>
                              <option value="hard">Hard</option>
                            </select>
                          </div>
                        </div>

                        {/* Confirmation */}
                        <div className="col-md-4">
                          <div className="form-group">
                            <label style={{ color: "Black" }}>
                              Confirmation
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              style={{
                                cursor: "pointer",
                                backgroundColor: "#fff",
                              }}
                              value={this.state.Confirmation}
                              readOnly
                              onClick={this.handleConfirmationClick}
                              placeholder="Select Confirmation"
                              data-toggle="modal"
                              data-target="#ConfirmInfoModal"
                            />
                          </div>
                        </div>
                      </div>

                      {/* Row 4: Priority, Report Status, Atrial Fib */}
                      <div className="row">
                        <div className="col-md-4">
                          <div className="form-group">
                            <label style={{ color: "Black" }}>Priority</label>
                            <select
                              className="form-control"
                              value={this.state.priority}
                              onChange={this.onPriorityChange}
                            >
                              <option value="4">NA</option>
                              <option value="1">1</option>
                              <option value="2">2</option>
                              <option value="3">3</option>
                              <option value="4">4</option>
                              <option value="5">5</option>
                            </select>
                          </div>
                        </div>

                        <div className="col-md-4">
                          <div className="form-group">
                            <label style={{ color: "Black" }}>
                              Report Status
                            </label>
                            <select
                              className="form-control"
                              value={this.state.reportstatus}
                              onChange={this.onReportStatuschange}
                            >
                              <option value="0">Not Analayzed</option>
                              <option value="6">Analyze Completed</option>
                              <option value="3">Verification Completed</option>
                              <option value="4">In Preparation</option>
                              <option value="5">Report Completed</option>
                            </select>
                          </div>
                        </div>

                        <div className="col-md-4">
                          <div className="form-group">
                            <label style={{ color: "Black" }}>
                              Atrial Fibrillation
                            </label>
                            <select
                              className="form-control"
                              value={this.state.af}
                              onChange={this.onChange}
                            >
                              <option value="">Choose</option>
                              <option value="yes">Yes</option>
                              <option value="no">No</option>
                            </select>
                          </div>
                        </div>
                      </div>

                      {/* Row 5: Indication, Duration, Gender */}
                      <div className="row">
                        <div className="col-md-4">
                          <div className="form-group">
                            <label style={{ color: "Black" }}>Indication</label>
                            <input
                              type="text"
                              className="form-control"
                              name="indication"
                              onChange={this.onChange}
                              value={this.state.indication}
                            />
                          </div>
                        </div>

                        <div className="col-md-4">
                          <div className="form-group">
                            <label style={{ color: "Black" }}>
                              Monitoring Duration
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              onChange={this.onDurationChange}
                              value={this.state.duration}
                            />
                          </div>
                        </div>

                        <div className="col-md-4">
                          <div className="form-group">
                            <label style={{ color: "Black" }}>Gender</label>
                            <select
                              className="form-control"
                              onChange={this.onGenderChange}
                              value={this.state.gender}
                            >
                              <option value="M">M</option>
                              <option value="F">F</option>
                            </select>
                          </div>
                        </div>
                      </div>

                      {/* Row 6: Issue Noticed, Cardiac Surgery, Pacemaker */}
                      <div className="row">
                        <div className="col-md-4">
                          <div className="form-group">
                            <label style={{ color: "Black" }}>
                              Issue Noticed
                            </label>
                            <select
                              className="form-control"
                              value={this.state.issueReport}
                              onChange={(e) =>
                                this.setState({ issueReport: e.target.value })
                              }
                            >
                              <option value="NA">Not Selected</option>
                              <option value="repeat">Repeat</option>
                              <option value="low_data">Low data</option>
                              <option value="customer_reject">
                                Customer Reject
                              </option>
                              <option value="battery_issue">
                                Battery Issue
                              </option>
                              <option value="device_issue">Device Issue</option>
                            </select>
                          </div>
                        </div>

                        <div className="col-md-4">
                          <div className="form-group">
                            <label style={{ color: "Black" }}>
                              Cardiac Surgery/Interventions
                            </label>
                            <select
                              className="form-control"
                              value={this.state.cardiac_surgery}
                              onChange={this.onChange}
                            >
                              <option value="yes">Yes</option>
                              <option value="no">No</option>
                            </select>
                          </div>
                        </div>

                        <div className="col-md-4">
                          <div className="form-group">
                            <label style={{ color: "Black" }}>Pacemaker</label>
                            <select
                              className="form-control"
                              value={this.state.pacemaker}
                              onChange={(e) => {
                                this.setState({
                                  pacemaker: e.target.value === "true",
                                });
                              }}
                            >
                              <option value="true">Yes</option>
                              <option value="false">No</option>
                            </select>
                          </div>
                        </div>
                      </div>
                      {/* Row 7: Support Person + Support Level + Supported Matter */}
                      <div className="row">
                        {/* Support Person Dropdown */}
                        {/* Support Person Dropdown */}
                        <div className="col-md-4">
                          <div className="form-group">
                            <label style={{ color: "Black" }}>
                              Support Person
                            </label>
                            <select
                              className="form-control"
                              value={this.state.supportPerson}
                              onChange={(e) =>
                                console.log(e.target.value) ||
                                this.setState({ supportPerson: e.target.value })
                              }
                            >
                              <option value="">Select Person</option>
                              {this.state.supportPersons &&
                              this.state.supportPersons.length > 0 ? (
                                this.state.supportPersons.map((person) => (
                                  <option key={person._id} value={person._id}>
                                    {person.name}
                                  </option>
                                ))
                              ) : (
                                <option disabled>Loading...</option>
                              )}
                            </select>
                          </div>
                        </div>

                        {/* Support Level Dropdown */}
                        <div className="col-md-2">
                          <div className="form-group">
                            <label style={{ color: "Black" }}>
                              Support Level
                            </label>
                            <select
                              className="form-control"
                              value={this.state.supportLevel}
                              onChange={(e) =>
                                console.log(e.target.value) ||
                                this.setState({ supportLevel: e.target.value })
                              }
                            >
                              <option value="">Select Level</option>
                              <option value="L0">L0</option>
                              <option value="L1">L1</option>
                              <option value="L2">L2</option>
                              <option value="L3">L3</option>
                            </select>
                          </div>
                        </div>

                        {/* Supported Matter Textarea */}
                        <div className="col-md-6">
                          <div className="form-group">
                            <label style={{ color: "Black" }}>
                              Supported Matter
                            </label>
                            <textarea
                              className="form-control"
                              rows="3"
                              value={this.state.supportedMatter}
                              onChange={(e) =>
                                // console.log(e.target.value) ||
                                this.setState({
                                  supportedMatter: e.target.value,
                                })
                              }
                              placeholder="Enter details..."
                            />
                          </div>
                        </div>
                      </div>

                      <div className="row">
                        <div className="col-md-4">
                          <div className="form-group">
                            <label style={{ color: "Black" }}>
                              Prioritize Data
                            </label>
                            <select
                              className="form-control"
                              value={this.state.prioritizeData}
                              onChange={(e) =>
                                this.setState({
                                  prioritizeData: e.target.value,
                                })
                              }
                            >
                              <option value="No">No</option>
                              <option value="Yes">Yes</option>
                            </select>
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-md-12">
                          <div className="form-group">
                            <label style={{ color: "Black" }}>
                              Assign Verifier
                            </label>
                            <Select
                              isMulti
                              options={this.state.verifiers}
                              value={this.state.selectedVerifiers}
                              onChange={this.handleVerifierChange}
                              className="basic-multi-select"
                              classNamePrefix="select"
                              placeholder="Select verifiers..."
                              styles={{
                                option: (provided, state) => ({
                                  ...provided,
                                  backgroundColor: state.isSelected
                                    ? "blue"
                                    : state.isFocused
                                    ? "#e5e5e5"
                                    : null,
                                  color: state.isSelected ? "white" : "black",
                                }),
                                multiValue: (provided) => ({
                                  ...provided,
                                  backgroundColor: "blue",
                                }),
                                multiValueLabel: (provided) => ({
                                  ...provided,
                                  color: "white",
                                }),
                              }}
                            />

                            {this.state.selectedVerifiers.length > 0 && (
                              <div style={{ marginTop: "10px" }}>
                                <strong>Selected Verifiers:</strong>{" "}
                                {this.state.selectedVerifiers
                                  .map((verifier) => verifier.label)
                                  .join(", ")}
                              </div>
                            )}
                          </div>
                        </div>
                      </div>

                      {/* Row 9: Clinical Condition */}
                      <div className="row">
                        <div className="col-md-12">
                          <div className="form-group">
                            <label style={{ color: "Black" }}>
                              Clinical Condition
                            </label>
                            <textarea
                              className="form-control"
                              rows="3"
                              value={this.state.clinicalCondition}
                              onChange={(e) =>
                                this.setState({
                                  clinicalCondition: e.target.value,
                                })
                              }
                              placeholder="Enter clinical condition..."
                            />
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* Footer with separate divs for Submit and Close */}
                    <div className="modal-footer d-flex justify-content-center gap-3">
                      <button
                        type="submit"
                        className="btn btn-success"
                        disabled={this.state.loadingEditModal}
                      >
                        Submit
                      </button>

                      <button
                        type="button"
                        className="btn btn-default closePopup"
                        data-dismiss="modal"
                      >
                        Close
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
            <div id="ConfirmInfoModal" className="modal fade" role="dialog">
              <div className="modal-dialog">
                <div className="modal-content">
                  <div className="modal-header">
                    <button
                      type="button"
                      className="close"
                      data-dismiss="modal"
                    >
                      &times;
                    </button>
                    <h4 className="modal-title text-center">
                      Confirmation Status
                    </h4>
                  </div>
                  <div className="modal-body">
                    <div className="form-group">
                      <label
                        className="form-control-label mbr-fonts-style display-7"
                        style={{ color: "Black" }}
                      >
                        Select Status
                      </label>
                      <select
                        className="form-control"
                        value={this.state.selectedConfirmation}
                        onChange={this.handleConfirmationChange}
                      >
                        <option value="">Select</option>
                        <option value="Yes">Yes</option>
                        <option value="No">No</option>
                        <option value="Hold">Hold</option>
                      </select>
                    </div>
                  </div>
                  <div className="modal-footer">
                    <button
                      type="button"
                      className="btn btn-success"
                      data-dismiss="modal"
                      onClick={this.handleConfirmationSubmit}
                    >
                      Submit
                    </button>
                    <button
                      type="button"
                      className="btn btn-default"
                      data-dismiss="modal"
                      onClick={this.handleConfirmationCancel}
                    >
                      Close
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-sm-12">
                <div style={{ background: "#0a1f20", border: "1px solid #1a3a3a", borderRadius: "10px", overflow: "hidden" }}>
                  <div style={{ padding: "14px 20px", borderBottom: "1px solid #1a3a3a", display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                    <h6 style={{ margin: 0, color: "#2eaabb", fontWeight: 700, fontSize: "15px", letterSpacing: "0.5px" }}>Labelled Patients</h6>
                    <input
                      type="text"
                      placeholder="Search..."
                      style={{
                        width: "180px",
                        padding: "5px 12px",
                        fontSize: "12px",
                        background: "#0f2d2e",
                        border: "1px solid #1a5a62",
                        borderRadius: "6px",
                        color: "#c8dde0",
                        outline: "none",
                      }}
                      value={this.state.searchQuery}
                      onChange={this.handleSearchChange}
                    />
                  </div>
                  <div style={{ overflowX: "auto" }}>
                    <table style={{ width: "100%", borderCollapse: "collapse", fontSize: "13px" }}>
                      <thead>
                        <tr style={{ background: "#0f3035" }}>
                          {columns.map((col, index) => (
                            <th
                              key={index}
                              style={{
                                padding: "10px 14px",
                                color: "#2eaabb",
                                fontWeight: 700,
                                fontSize: "11px",
                                letterSpacing: "0.8px",
                                textTransform: "uppercase",
                                borderBottom: "1px solid #1a3a3a",
                                textAlign: col.label === "Action" ? "center" : "left",
                                whiteSpace: "nowrap",
                              }}
                            >
                              {col.label}
                            </th>
                          ))}
                        </tr>
                      </thead>
                      <tbody>
                        {displayedRows.map((row, rowIndex) => (
                          <tr
                            key={rowIndex}
                            style={{
                              background: rowIndex % 2 === 0 ? "#0a1f20" : "#0d2628",
                              borderBottom: "1px solid #132e30",
                            }}
                          >
                            <td style={{ padding: "9px 14px", color: "#89a8c0", verticalAlign: "middle", textAlign: "center" }}>{startIndex + rowIndex + 1}</td>
                            <td
                              onClick={this.handleRowClick}
                              style={{ padding: "9px 14px", color: "#c8dde0", cursor: "pointer", verticalAlign: "middle" }}
                            >
                              {row.patientId}
                            </td>
                            <td
                              onClick={this.handleRowClick}
                              style={{ padding: "9px 14px", color: "#c8dde0", cursor: "pointer", verticalAlign: "middle" }}
                            >
                              {row.added_date}
                            </td>
                            <td
                              onClick={this.handleRowClick}
                              style={{ padding: "9px 14px", color: "#c8dde0", cursor: "pointer", verticalAlign: "middle" }}
                            >
                              {row.name}
                            </td>
                            <td style={{ padding: "9px 14px", verticalAlign: "middle", textAlign: "center" }}>{row.action}</td>
                            <td style={{ padding: "9px 14px", verticalAlign: "middle", width: "400px" }}>{row.report}</td>
                            <td style={{ padding: "9px 14px", color: "#c8dde0", verticalAlign: "middle" }}>{row.monitoring_duration}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>

                  {/* Pagination */}
                  <div style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: "6px", padding: "12px 16px", borderTop: "1px solid #1a3a3a" }}>
                    <button
                      onClick={this.handlePrevPage}
                      disabled={currentPage === 1}
                      style={{
                        padding: "5px 16px",
                        fontSize: "12px",
                        borderRadius: "6px",
                        border: "1px solid #2eaabb",
                        background: currentPage === 1 ? "#0f3035" : "#1a5a62",
                        color: currentPage === 1 ? "#3a6a72" : "#c8dde0",
                        cursor: currentPage === 1 ? "not-allowed" : "pointer",
                      }}
                    >
                      ‹ Prev
                    </button>
                    {paginationNumbers.map((num) => (
                      <button
                        key={num}
                        onClick={() => this.handlePageChange(num)}
                        style={{
                          padding: "5px 10px",
                          fontSize: "12px",
                          borderRadius: "6px",
                          border: "1px solid #2eaabb",
                          background: num === currentPage ? "#2eaabb" : "#0f2d2e",
                          color: num === currentPage ? "#0a1f20" : "#89a8c0",
                          fontWeight: num === currentPage ? 700 : 400,
                          cursor: "pointer",
                        }}
                      >
                        {num}
                      </button>
                    ))}
                    <button
                      onClick={this.handleNextPage}
                      disabled={currentPage === totalPages}
                      style={{
                        padding: "5px 16px",
                        fontSize: "12px",
                        borderRadius: "6px",
                        border: "1px solid #2eaabb",
                        background: currentPage === totalPages ? "#0f3035" : "#1a5a62",
                        color: currentPage === totalPages ? "#3a6a72" : "#c8dde0",
                        cursor: currentPage === totalPages ? "not-allowed" : "pointer",
                      }}
                    >
                      Next ›
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default LabledPatients;
